<template>
	<div class="bg-fill-secondary rounded-xl p-0.5">
		<BaseCard class="flex w-full gap-4 rounded-[10px]!" :class="topClass">
			<slot name="top" />
		</BaseCard>
		<div class="mt-0.5 flex gap-2 px-3.5 py-3" :class="bottomClass">
			<slot name="bottom" />
		</div>
	</div>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'

defineProps<{
	topClass?: string
	bottomClass?: string
}>()
</script>
